import React from 'react';


const About = () => {
 

  return (
    <>
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">About Us</h1>
          <p className="page-subtitle">Crafting Sweet Moments</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2 className="content-title">Our Story</h2>
         <p>Located in the heart of Groblersdal, Sweet & Snack World is your go-to destination for delicious treats, snacks, and beverages for every occasion. Whether you’re craving something sweet, salty, or a little bit of both, we offer a wide variety of quality products to satisfy every taste. Our friendly team is passionate about providing excellent service and ensuring every visit leaves you with a smile. Come experience the perfect blend of flavor, freshness, and fun at Sweet & Snack World!</p>
            </div>
            <div className="about-visual">
              <div className="visual-card">
                <div className="visual-icon">🌟</div>
                <h3>Our Mission</h3>
                <p>To spread happiness one sweet at a time, creating magical moments through extraordinary flavors</p>
              </div>
            </div>
          </div>

         
          
        </div>
      </section>
    </>
  );
};

export default About;
